import { FunctionComponent } from 'react';
import { Global, css } from '@emotion/react';
import { Theme, InkDocuSignTheme, CustomBranding } from '@ds/ui';
import { inkButtonTokens } from '@ds/tokens';
import { color } from '@ds/tokens/dist/ink/primitives';
import { AppMessenger } from '@ds/components';

//--tile-hover-border-color: rgba(25, 24, 35, 0.9); - should be ${inkButtonTokens.secondary.hoverBorderColor}; but that's not defined in the token...
const ApplicationLayoutGlobalStyles = css`
    html,
    body,
    #root {
        height: 100%;
        --tile-background-color: ${inkButtonTokens.secondary.hoverBackgroundColor};
        --tile-border-color: ${inkButtonTokens.secondary.defaultBorderColor};
        --tile-hover-border-color: rgba(25, 24, 35, 0.9);
        --tile-border-radius: 2px;
        --tile-hover-background-color: ${inkButtonTokens.secondary.hoverBackgroundColor};
        --tile-active-background-color: ${inkButtonTokens.secondary.activeBackgroundColor};
        --tile-focuse-outline-color: ${color.semanticBlue[50]} solid 2px;
        --tile-focus-outline-offset: -2px;
        --one-country-background-color: ${inkButtonTokens.secondary.hoverBackgroundColor};
        --tile-height: 80px;
        --tile-icon-width: 38px;
        --onfido-sdk-button-radius: 2px;
    }

    #root {
        display: flex;
        flex-direction: column;
        min-width: 320px;
    }

    .hidden {
        display: none;
    }

    .inline {
        display: inline;
    }

    [tabIndex='-1']:focus {
        outline: none;
    }

    #root > footer {
        overflow: visible;
    }
`;

export interface ApplicationLayoutProps {
    header: FunctionComponent;
    content: FunctionComponent;
    footer: FunctionComponent;
    accountBranding?: CustomBranding;
}

const ApplicationLayout: FunctionComponent<ApplicationLayoutProps> = ({ header: Header, content: Content, footer: Footer, accountBranding }) => (
    <Theme enableGlobalCss enableFontFaceDeclarations docuSignTheme={InkDocuSignTheme} accountBranding={accountBranding}>
        <AppMessenger>
            <Global styles={ApplicationLayoutGlobalStyles} />
            <Header />
            <Content />
            <Footer />
        </AppMessenger>
    </Theme>
);

export default ApplicationLayout;
